import $ from "jquery";
import "magnific-popup";

export default function openObjectModal() {
  $(".js-open-object-modal").magnificPopup({
    type: "inline",
    callbacks: {
      open: function () {
        triggerForm();
      },
      close: function () {},
      change: function () {
        const objects = this.content
          .get(0)
          .querySelectorAll(".floorplan-object");

        objects.forEach((object) => {
          const objectID = object.getAttribute("href");

          const status = document
            .querySelector(
              `.js-objects-floorplan-list-item[data-id='${objectID}']`
            )
            .getAttribute("data-status");

          object.dataset.status = status;
        });
      },
    },
  });

  $(".close-object-modal").click(function () {
    $(".mfp-close").trigger("click");
  });

  $(".modal-menu").click(function () {
    $(this).parent().find(".modal-menu").removeClass("active");
    $(this).addClass("active");
  });

  function triggerForm() {
    const formWrapper = document.querySelector(".object-form-overlay");
    const trigger = document.querySelector(".js-open-object-form");
    const close = document.querySelector(".js-close-object-form");

    const objTitle = trigger.getAttribute("data-object-title");
    const objID = trigger.getAttribute("data-object-id");
    const prjID = trigger.getAttribute("data-project-id");
    const itemID = trigger.getAttribute("data-item-id");

    trigger.addEventListener("click", function () {
      formWrapper.classList.add("visible");

      $(".js-form-object-title input").val(objTitle);
      $(".js-form-object-id input").val(objID);
      $(".js-form-project-id input").val(prjID);
      $(".js-form-item-id input").val(itemID);
    });

    close.addEventListener("click", function () {
      formWrapper.classList.remove("visible");
    });

    window.onkeydown = function (event) {
      if (event.keyCode == 27) {
        formWrapper.classList.remove("visible");
      }
    };

    $(".object-form-overlay").focusin(function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
    });
  }
}
